(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/transcript-card-history.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/transcript-card-history.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  CardBody,
  CardExpandableBody
} = svs.ui.ReactCard;
const {
  WhiteCardHeader,
  PdCard
} = svs.myProfile.react.pages.myInformation.myInformation.components;
const {
  TranscriptOrderedDownload,
  TranscriptOrderedThankYou
} = svs.myProfile.react.pages.myInformation.transcript.transcript;
const isPnp = svs.core.config.data.svsconfig.site === 'momang';

const TranscriptCardHistory = _ref => {
  let {
    handleOrderClick,
    orderNumber,
    text,
    transcript
  } = _ref;
  return React.createElement(PdCard, null, React.createElement(WhiteCardHeader, null, text), React.createElement(CardBody, {
    className: "f-left pd-card-body"
  }, (transcript === null || transcript === void 0 ? void 0 : transcript.OrderStatus) === 'READY' && React.createElement("p", null, "Ditt utdrag \xE4r redo att h\xE4mtas.")), React.createElement(CardExpandableBody, {
    className: "f-left pd-card-body"
  }, !transcript && React.createElement(React.Fragment, null, React.createElement("p", null, "Du kan best\xE4lla, och ladda ner, ett utdrag fr\xE5n", ' ', orderNumber === '2' ? text : 'din kontohistorik', ' ', "i CSV format"), React.createElement(Button, {
    block: true,
    className: "margin-v-2",
    inverted: true,
    onClick: () => handleOrderClick(orderNumber),
    size: 300,
    transparent: isPnp
  }, "Best\xE4ll utdrag av", ' ', text)), (transcript === null || transcript === void 0 ? void 0 : transcript.OrderStatus) === 'READY' && React.createElement(TranscriptOrderedDownload, {
    transcript: transcript,
    transcriptType: text
  }), (transcript === null || transcript === void 0 ? void 0 : transcript.OrderStatus) === 'NOTREADY' && React.createElement(TranscriptOrderedThankYou, {
    thankYouText: "utdrag"
  })));
};
svs.myProfile.react.pages.myInformation.transcript.transcript.TranscriptCardHistory = TranscriptCardHistory;

 })(window);